<template>
    <div class="AccountManagement">
        <HandMenu/>
        <el-card shadow="never" style="border: 0;border-right: 1px solid #EBEEF5;">
            <el-row :gutter="20">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                </el-breadcrumb>
                <div v-loading="loading">
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="12" :md="8" :lg="5" :xl="4">
                        <el-input placeholder="输入用户账号搜索" @input="selectTable" v-model="account"
                                  class="input-with-select">
                        </el-input>
                    </el-col>
                    <el-col style="margin-bottom: 10px" :xs="24" :sm="24" :md="24" :lg="9" :xl="12">
                        <el-button type="success" @click="clearSelect" plain>清空</el-button>
                        <el-button type="info" @click="refreshTable" plain>刷新</el-button>
                        <el-button type="warning" @click="addDialogVisible=true" plain>添加账号</el-button>
                    </el-col>
                    <el-table
                            :data="tableData"
                            border
                            :header-cell-style="cellStyle"
                            :cell-style="cellStyle"
                            style="width: 100%">
                        <el-table-column
                                fixed
                                type="index"
                                label="#"
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="userAcc"
                                label="账号"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="userName"
                                label="用户名"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="roleInf.roleName"
                                label="角色名"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="liveAddr"
                                label="直播地址"
                        >
                        </el-table-column>
                        <el-table-column
                                fixed="right"
                                label="操作"
                                width="150">
                            <template slot-scope="scope">
                                <el-button slot="reference" type="text" size="small"
                                           @click="openChangeDialog(scope.row)">修改
                                </el-button>
                                <el-button slot="reference" type="text" size="small"
                                            @click="resetPass(scope.row)">重置密码</el-button>
                                <!--删除内容的按钮-->
                                <el-popconfirm
                                        style="margin-left: 10px;"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        title="账号关联的文章/活动也将被一起删除，请确认！"
                                        @onConfirm="deleteUser(scope.row)"
                                >
                                    <el-button slot="reference" type="text" size="small">删除</el-button>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页器-->
                    <div class="block" style="margin-top: 10px;text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 20, 30]"
                                :page-size="10"
                                layout="prev, pager, next, jumper,sizes"
                                :total="accountTotal">
                        </el-pagination>
                    </div>
                </div>
            </el-row>
        </el-card>
        <!--#################添加对话框#################-->
        <el-dialog
                title="添加账号"
                :visible.sync="addDialogVisible"
                width="30%">
            <!--账号输入框-->
            <div>
                <el-input placeholder="请输入账号" v-model="addAcc">
                    <template slot="prepend">用户账号：</template>
                </el-input>
            </div>
            <!--密码输入框-->
            <div style="margin-top: 10px;">
                <el-input placeholder="请输入密码" show-password v-model="addPass">
                    <template slot="prepend">用户密码：</template>
                </el-input>
            </div>
            <!--用户名-->
            <div style="margin-top: 10px;">
                <el-input placeholder="请输入用户名" v-model="addUserName">
                    <template slot="prepend">用户名：</template>
                </el-input>
            </div>
            <!--直播地址输入框-->
            <div style="margin-top: 10px;">
                <el-input placeholder="请输入该账号支部的直播地址(没有请随意填写内容)" v-model="addLiveAddr">
                    <template slot="prepend">直播地址：</template>
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <el-select v-model="addSelectRole" style="width: 100%;" placeholder="请选择用户角色">
                    <el-option
                            v-for="item in roleSelectOption"
                            :key="item.roleId"
                            :label="item.roleName"
                            :value="item.roleId">
                    </el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="addDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addNewUser">确 定</el-button>
            </span>
        </el-dialog>
        <!--#################修改对话框#################-->
        <el-dialog
                title="修改账号"
                :visible.sync="changeDialogVisible"
                width="30%">
            <!--账号输入框-->
            <div>
                <el-input placeholder="请输入账号" :disabled="true" v-model="changeAcc">
                    <template slot="prepend" >用户账号：</template>
                </el-input>
            </div>
            <!--用户名-->
            <div style="margin-top: 10px;">
                <el-input placeholder="请输入用户名" v-model="changeUserName">
                    <template slot="prepend">用户名：</template>
                </el-input>
            </div>
            <!--直播地址输入框-->
            <div style="margin-top: 10px;">
                <el-input placeholder="请输入该账号支部的直播地址(没有请随意填写内容)" v-model="changeLiveAddr">
                    <template slot="prepend">直播地址：</template>
                </el-input>
            </div>
            <div style="margin-top: 10px;">
                <el-select v-model="changeSelectRole" style="width: 100%;" placeholder="请选择用户角色">
                    <el-option
                            v-for="item in roleSelectOption"
                            :key="item.roleId"
                            :label="item.roleName"
                            :value="item.roleId">
                    </el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="changeDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="updateUserInf">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import axios from "../../api";
    import Vue from "../../main";

    export default {
        name: "AccountManagement",
        data() {
            return {
                //表格内容
                tableData: [],
                //分页器 当前页数
                currentPage: 1,
                //分页器 每页显示几条
                pageSize: 10,
                //总共有多少条数据
                accountTotal: 0,
                //加载遮罩
                loading: true,
                //搜索账号
                account: "",
                //添加 修改的角色下拉框
                roleSelectOption: [],
                //-------------------修改对话框-------------------------
                addDialogVisible: false,
                //添加的三个输入框
                addAcc: "",
                addPass: "",
                addUserName: "",
                addLiveAddr: "",
                //添加的select选择器
                addSelectRole: "",
                //-------------------修改对话框-------------------------
                changeUserInf: {},
                changeDialogVisible: false,
                //修改的三个输入框
                changeAcc: "",
                changeUserName: "",
                changeLiveAddr: "",
                //修改的select选择器
                changeSelectRole: "",
            }
        },
        methods: {
            //清除搜索框
            clearSelect() {
                this.account = "";
                this.time = [];
            },
            //分页器 当前每页几条
            handleSizeChange(val) {
                this.loading = true;
                this.pageSize = val;
                this.getTableData();
            },
            //分页器当前在第几页
            handleCurrentChange(val) {
                this.loading = true;
                this.currentPage = val;
                this.getTableData();
            },
            cellStyle({columnIndex}) {
                //让序号那一列居中
                if (columnIndex === 0) {
                    // 指定列号
                    return 'text-align: center;'
                } else {
                    return ''
                }
            },
            //获取表格内容
            getTableData() {
                let self = this;
                axios.getAccountList({
                    //当前页
                    page: self.currentPage,
                    //搜索标题
                    title: self.account,
                    //每页显示几条
                    showCount: self.pageSize
                }).then(res => {
                    //设置table内容
                    self.tableData = res.data.accountList;
                    //设置总页数
                    self.accountTotal = res.data.total;
                    self.loading = false;
                })
            },
            //获取所有角色
            initRoleInf() {
                let self = this;
                axios.getRoleInf().then(res => {
                    self.roleSelectOption = res.data.roleInfList;
                })
            },
            //刷新表格
            refreshTable() {
                //获取内容
                this.getTableData();
            },
            //搜索
            selectTable() {
                //设置当前页为1
                this.currentPage = 1;
                //获取内容
                this.getTableData();
            },
            addNewUser() {
                let self = this;
                if (self.addAcc.replace(/\s*/g, "") === "" || self.addAcc == null) {
                    Vue.$message({
                        message: "请输入用户账号！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (self.addPass.replace(/\s*/g, "") === "" || self.addPass == null) {
                    Vue.$message({
                        message: "请填写用户密码！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (self.addUserName.replace(/\s*/g, "") === "" || self.addUserName == null) {
                    Vue.$message({
                        message: "请输入用户名！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (self.addLiveAddr.replace(/\s*/g, "") === "" || self.addLiveAddr == null) {
                    Vue.$message({
                        message: "请输入直播地址，如果没有请随意输入内容弄！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (self.addSelectRole === "" || self.addSelectRole == null) {
                    Vue.$message({
                        message: "请选择账号对应的角色！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                axios.insertUser({
                    userAcc: self.addAcc,
                    userPass: self.addPass,
                    userName: self.addUserName,
                    userLiveAddr: self.addLiveAddr,
                    userRole: self.addSelectRole
                }).then(res => {
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "success"
                        });
                        //清除输入框的内容
                        self.addDialogVisible = false;
                        self.addAcc = '';
                        self.addPass = "";
                        self.addUserName = "";
                        self.addLiveAddr = "";
                        self.addSelectRole = "";
                        //设置当前页为1
                        self.currentPage = 1;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //打开修改对话框
            openChangeDialog(row) {
                let self = this;
                self.changeUserInf = row;
                self.changeAcc = row.userAcc;
                self.changeUserName = row.userName;
                self.changeLiveAddr = row.liveAddr;
                self.changeSelectRole = row.roleId;
                self.changeDialogVisible= true;
            },
            //更新用户信息
            updateUserInf(){
                let self = this;
                if (self.changeUserName.replace(/\s*/g, "") === "" || self.changeUserName == null) {
                    Vue.$message({
                        message: "请输入用户名！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (self.changeLiveAddr.replace(/\s*/g, "") === "" || self.changeLiveAddr == null) {
                    Vue.$message({
                        message: "请输入直播地址，如果没有请随意输入内容弄！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (self.changeSelectRole === "" || self.changeSelectRole == null) {
                    Vue.$message({
                        message: "请选择账号对应的角色！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                axios.updateUserInf({
                    userId:self.changeUserInf.userId,
                    userName: self.changeUserName,
                    userLiveAddr: self.changeLiveAddr,
                    userRole: self.changeSelectRole
                }).then(res=>{
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "success"
                        });
                        self.changeDialogVisible = false;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //重置密码
            resetPass(row){
                axios.resetPass({
                    userId:row.userId
                }).then(res=>{
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 5000,
                            type: "success"
                        });
                        self.changeDialogVisible = false;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //删除账号
            deleteUser(row){
                let self = this;
                axios.deleteUser({
                    userId:row.userId
                }).then(res=>{
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: res.data.content,
                            duration: 5000,
                            type: "success"
                        });
                        self.changeDialogVisible = false;
                        self.currentPage = 1;
                        //获取内容
                        self.getTableData();
                    } else {
                        Vue.$message({
                            message: res.data.content,
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            }

        },
        mounted() {
            this.getTableData();
            this.initRoleInf();
        }
    }
</script>

<style scoped>
    .AccountManagement {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }
</style>
